import React, { useState } from 'react';
import './LocationSectionInspector.css';

function LocationSectionInspector({ 
  func, 
  index, 
  onUpdate,
  isIconPickerOpen,
  setIsIconPickerOpen,
  iconPickerPosition,
  setIconPickerPosition,
  setActiveIconPreview,
  bringToFront
}) {
  const [expandedLocations, setExpandedLocations] = useState({});

  const toggleLocation = (locationIndex) => {
    setExpandedLocations(prev => ({
      ...prev,
      [locationIndex]: !prev[locationIndex]
    }));
  };

  const handleLocationChange = (locationIndex, field, value) => {
    const newLocations = [...(func.props.locations || [])];
    newLocations[locationIndex] = {
      ...newLocations[locationIndex],
      [field]: value
    };
    onUpdate(index, { ...func.props, locations: newLocations });
  };

  const handleIconChange = (locationIndex, field, value) => {
    console.log('handleIconChange called with:', { locationIndex, field, value });
    
    const newLocations = [...(func.props.locations || [])];
    if (field === 'icon') {
      // Handle full icon object update
      newLocations[locationIndex] = {
        ...newLocations[locationIndex],
        icon: value
      };
    } else {
      // Handle individual field update
      newLocations[locationIndex] = {
        ...newLocations[locationIndex],
        icon: {
          ...(newLocations[locationIndex].icon || {}),
          [field]: value
        }
      };
    }
    
    console.log('Updated location:', newLocations[locationIndex]);
    onUpdate(index, { ...func.props, locations: newLocations });
  };

  const addLocation = () => {
    const newLocations = [...(func.props.locations || []), {
      title: "",
      city: "",
      venue: "",
      time: "",
      mapUrl: "",
      mapButtonText: "Show on map",
      icon: {
        svg_path: "",
        viewBox: "0 0 541 591"
      }
    }];
    onUpdate(index, { ...func.props, locations: newLocations });
  };

  const removeLocation = (locationIndex) => {
    const newLocations = func.props.locations.filter((_, idx) => idx !== locationIndex);
    onUpdate(index, { ...func.props, locations: newLocations });
  };

  return (
    <div className="location-section-inspector">
      {(func.props.locations || []).map((location, locationIndex) => (
        <div key={locationIndex} className="location-item">
          <div className="location-header" onClick={() => toggleLocation(locationIndex)}>
            <h3>Location {locationIndex + 1}</h3>
            <div className="header-buttons">
              <button 
                className={`collapse-button ${expandedLocations[locationIndex] ? 'expanded' : ''}`}
              >
                ▼
              </button>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  removeLocation(locationIndex);
                }}
                className="remove-button"
                title="Remove location"
              >
                ×
              </button>
            </div>
          </div>

          <div className={`location-content ${expandedLocations[locationIndex] ? 'expanded' : ''}`}>
            <div className="location-fields">
              <div className="input-group">
                <label>Title</label>
                <input
                  type="text"
                  value={location.title || ''}
                  onChange={(e) => handleLocationChange(locationIndex, 'title', e.target.value)}
                  className="full-width-input"
                />
              </div>

              <div className="input-group">
                <label>City</label>
                <input
                  type="text"
                  value={location.city || ''}
                  onChange={(e) => handleLocationChange(locationIndex, 'city', e.target.value)}
                  className="full-width-input"
                />
              </div>

              <div className="input-group">
                <label>Venue</label>
                <input
                  type="text"
                  value={location.venue || ''}
                  onChange={(e) => handleLocationChange(locationIndex, 'venue', e.target.value)}
                  className="full-width-input"
                />
              </div>

              <div className="input-group">
                <label>Time</label>
                <input
                  type="text"
                  value={location.time || ''}
                  onChange={(e) => handleLocationChange(locationIndex, 'time', e.target.value)}
                  className="full-width-input"
                />
              </div>

              <div className="input-group">
                <label>Map Button Text</label>
                <input
                  type="text"
                  value={location.mapButtonText || ''}
                  onChange={(e) => handleLocationChange(locationIndex, 'mapButtonText', e.target.value)}
                  className="full-width-input"
                />
              </div>

              <div className="input-group">
                <label>Map URL</label>
                <input
                  type="text"
                  value={location.mapUrl || ''}
                  onChange={(e) => handleLocationChange(locationIndex, 'mapUrl', e.target.value)}
                  className="full-width-input"
                />
              </div>

              <div className="icon-section">
                <div className="icon-inputs">
                  <div className="input-group">
                    <label>ViewBox</label>
                    <input
                      type="text"
                      value={location.icon?.viewBox || ''}
                      onChange={(e) => handleIconChange(locationIndex, 'viewBox', e.target.value)}
                      placeholder="e.g. 0 0 512 512"
                      className="full-width-input"
                    />
                  </div>
                  <div className="input-group">
                    <label>SVG Path</label>
                    <input
                      type="text"
                      value={location.icon?.svg_path || ''}
                      onChange={(e) => handleIconChange(locationIndex, 'svg_path', e.target.value)}
                      placeholder="SVG path data"
                      className="full-width-input"
                    />
                  </div>
                </div>
                <div 
                  className="icon-preview"
                  onClick={(e) => {
                    console.log('Location icon preview clicked');
                    // Store the location index in the format "parentIndex-locationIndex"
                    setActiveIconPreview({ 
                      index: `${index}-${locationIndex}`
                    });
                    setIsIconPickerOpen(true);
                    bringToFront('iconPicker');
                    e.stopPropagation();
                  }}
                  title="Click to change icon"
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox={location.icon?.viewBox}
                    style={{ verticalAlign: 'middle' }}
                    className="preview-svg"
                  >
                    <path d={location.icon?.svg_path} />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
      
      <button 
        onClick={addLocation}
        className="add-button"
      >
        + Add Location
      </button>
    </div>
  );
}

export default LocationSectionInspector; 